import { useMemo } from "react";
import { useVocabulary } from "./useVocabulary";
import { getFieldOptions } from "../utils/vocabulary";

/**
 * Catalog-fed dropdown options for a managed enum field, sourced live from the
 * vocabulary catalog. Admin-added terms appear with no rebuild. Returns
 * `{ options, isLoading }`; `options` is [] until the catalog loads or for
 * unmanaged fields.
 */
export function useFieldOptions(field: string) {
  const { index, isLoading } = useVocabulary();
  const options = useMemo(() => getFieldOptions(index, field), [index, field]);
  return { options, isLoading };
}
